/*
  Behavior port for Drink Recovery (same system as vit2go-energy-exact.js):
  scroll-reveal, gallery (arrows/thumbs/swipe/keyboard), pack-radio <->
  gallery two-way sync, single-open formula accordion, and real
  add-to-cart via Shopify's native /cart/add.js.

  Unlike Energy, there's no per-ingredient formula photo to swap (no real
  ingredient photography exists yet for Drink Recovery — the formula
  panel is a placeholder), so this version keeps the single-open
  accordion behavior but drops the image-swap logic.
*/
(function () {
  "use strict";

  function init(root) {
    root.classList.add("js");

    var shopSec = root.querySelector(".shop-sec");
    requestAnimationFrame(function () {
      root.querySelectorAll(".shop-sec .r").forEach(function (el) { el.classList.add("in"); });
    });
    var targets = [].filter.call(root.querySelectorAll(".r"), function (el) {
      return !shopSec || !shopSec.contains(el);
    });
    if (!("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("in"); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add("in"); io.unobserve(entry.target); }
        });
      }, { rootMargin: "0px 0px 200px 0px", threshold: 0 });
      targets.forEach(function (el) { io.observe(el); });
    }

    var thumbs = [].slice.call(root.querySelectorAll('[data-v2g-dr-thumbs] [data-v2g-dr-thumb]'));
    var track = root.querySelector('[data-v2g-dr-track]');
    var goGallery = function () {};
    if (track) {
      var slides = track.children.length, i = 0;
      function go(n) {
        i = (n + slides) % slides;
        track.style.transform = "translateX(" + (-i * 100) + "%)";
        thumbs.forEach(function (b, x) { b.setAttribute("aria-current", x === i ? "true" : "false"); });
      }
      goGallery = go;
      var prevBtn = root.querySelector('[data-v2g-dr-prev]');
      var nextBtn = root.querySelector('[data-v2g-dr-next]');
      if (prevBtn) prevBtn.addEventListener("click", function () { go(i - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { go(i + 1); });
      thumbs.forEach(function (b, x) { b.addEventListener("click", function () { go(x); }); });

      var stage = root.querySelector('[data-v2g-dr-stage]');
      if (stage) {
        stage.setAttribute("tabindex", "0");
        stage.addEventListener("keydown", function (e) {
          if (e.key === "ArrowLeft") { e.preventDefault(); go(i - 1); }
          if (e.key === "ArrowRight") { e.preventDefault(); go(i + 1); }
        });
        var x0 = null;
        stage.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener("touchend", function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        }, { passive: true });
      }
    }

    var packInputs = [].slice.call(root.querySelectorAll('input[name="v2g-dr-pack"]'));
    var variantInput = root.querySelector('[data-v2g-dr-variant-id]');
    var priceEl = root.querySelector('[data-v2g-dr-price]');
    var priceSubEl = root.querySelector('[data-v2g-dr-price-sub]');

    function updatePack(syncGallery) {
      var selected = root.querySelector('input[name="v2g-dr-pack"]:checked');
      if (!selected) return;
      if (variantInput) variantInput.value = selected.value;
      if (priceEl) priceEl.innerHTML = selected.dataset.price + ' <span class="note">' + selected.dataset.note + "</span>";
      if (priceSubEl) priceSubEl.textContent = selected.dataset.sub || "";
      if (syncGallery !== false) {
        var slide = parseInt(selected.dataset.slide || "0", 10);
        if (!isNaN(slide)) goGallery(slide);
      }
    }
    packInputs.forEach(function (input) {
      input.addEventListener("change", function () { updatePack(true); });
    });
    thumbs.forEach(function (b, x) {
      b.addEventListener("click", function () {
        if (packInputs[x]) { packInputs[x].checked = true; updatePack(false); }
      });
    });
    updatePack(true);

    // ---- Formula ingredient accordion -> image swap ------------------------
    var formulaVisual = root.querySelector('[data-v2g-dr-formula-img]');
    var formulaDetails = [].slice.call(root.querySelectorAll('[data-v2g-dr-formula] details[data-ingredient]'));
    var formulaMap = {};
    if (formulaVisual && formulaVisual.dataset.map) {
      try { formulaMap = JSON.parse(formulaVisual.dataset.map); } catch (e) { formulaMap = {}; }
    }
    function setFormulaVisual(key) {
      if (!formulaVisual) return;
      formulaVisual.style.opacity = "0";
      formulaVisual.style.transform = "scale(.985)";
      setTimeout(function () {
        formulaVisual.src = formulaMap[key] || formulaMap.magnesium;
        formulaVisual.style.opacity = "1";
        formulaVisual.style.transform = "scale(1)";
      }, 120);
    }
    formulaDetails.forEach(function (det) {
      det.addEventListener("toggle", function () {
        if (det.open) {
          formulaDetails.forEach(function (other) { if (other !== det) other.open = false; });
          setFormulaVisual(det.dataset.ingredient);
        }
      });
    });

    var qtyValueEl = root.querySelector('[data-v2g-dr-qty-value]');
    var qtyDecBtn = root.querySelector('[data-v2g-dr-qty-decrease]');
    var qtyIncBtn = root.querySelector('[data-v2g-dr-qty-increase]');
    var qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyValueEl) qtyValueEl.textContent = qty;
    }
    if (qtyDecBtn) qtyDecBtn.addEventListener("click", function () { setQty(qty - 1); });
    if (qtyIncBtn) qtyIncBtn.addEventListener("click", function () { setQty(qty + 1); });

    var addBtn = root.querySelector('[data-v2g-dr-add]');
    if (addBtn && variantInput) {
      addBtn.addEventListener("click", function () {
        var selected = root.querySelector('input[name="v2g-dr-pack"]:checked');
        if (!selected || !variantInput.value) return;
        var oldLabel = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = "Toevoegen…";

        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: variantInput.value, quantity: qty }] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart.js").then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent("vit2go:cart:updated", { detail: cart }));
            addBtn.textContent = "Toegevoegd: " + (selected.dataset.added || selected.dataset.name || selected.value);
            setQty(1);
          })
          .catch(function () {
            addBtn.textContent = "Er ging iets mis — probeer opnieuw";
          })
          .finally(function () {
            setTimeout(function () { addBtn.textContent = oldLabel; addBtn.disabled = false; }, 1600);
          });
      });
    }

    // ---- Equalize pack-card heights (CSS Grid sizes each row by its own
    // content, so shorter text in one row leaves it shorter than a row
    // whose title/subtitle happens to wrap) ---------------------------------
    var boxes = [].slice.call(root.querySelectorAll(".opt-grid .opt .box"));
    if (boxes.length) {
      var equalize = function () {
        boxes.forEach(function (b) { b.style.minHeight = ""; });
        var max = boxes.reduce(function (m, b) { return Math.max(m, b.getBoundingClientRect().height); }, 0);
        boxes.forEach(function (b) { b.style.minHeight = max + "px"; });
      };
      equalize();
      var resizeTimer;
      window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(equalize, 150);
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-v2g-dr]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", boot);
  }
})();
